import { appRoutesUrls } from "constants/appRoutesUrls";
import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const currentUserInfo = process.env.CURRENT_USER_INFO;
const currentUserToken = process.env.CURRENT_USER_TOKEN;

const AuthContext = createContext();

const setUserInfo = (key, value) => localStorage.setItem(key, value);

const removeUserInfo = (key) => localStorage.removeItem(key);

const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem(process.env.CURRENT_USER_TOKEN));
    const navigate = useNavigate();

    const saveUserInfo = (token) => {
        setToken(token);
        //setCurrentUser(null);
        setUserInfo(currentUserToken, token);
    }

    const logout = () => {
        setToken("");
        //setCurrentUser(null);
        removeUserInfo(currentUserToken);
        navigate(appRoutesUrls.login());
    };

    return (
        <AuthContext.Provider value={{ currentUser, token, saveUserInfo, logout }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext);
};
